export const DRAFT_STORAGE_KEY = "zofino:product-brief-builder:draft:v1";

export const steps = [
    {id: "basic", titleKey: "pbb-step-basic"},
    {id: "problem", titleKey: "pbb-step-problem"},
    {id: "scenario", titleKey: "pbb-step-scenario"},
    {id: "outcome", titleKey: "pbb-step-outcome"},
    {id: "boundaries", titleKey: "pbb-step-boundaries"},
    {id: "review", titleKey: "pbb-step-review"},
];

export const requestTypes = [
    {labelKey: "pbb-request-new-feature", value: "new-feature"},
    {labelKey: "pbb-request-behavior-change", value: "behavior-change"},
    {labelKey: "pbb-request-ui-improvement", value: "ui-improvement"},
    {labelKey: "pbb-request-bugfix", value: "bugfix"},
];

export const priorities = [
    {labelKey: "pbb-priority-critical", value: "critical"},
    {labelKey: "pbb-priority-high", value: "high"},
    {labelKey: "pbb-priority-medium", value: "medium"},
    {labelKey: "pbb-priority-low", value: "low"},
];

export const codexModes = [
    {labelKey: "pbb-mode-analysis", value: "analysis"},
    {labelKey: "pbb-mode-frontend-after-receipt", value: "frontend-after-receipt"},
    {labelKey: "pbb-mode-ui-only", value: "ui-only"},
    {labelKey: "pbb-mode-bugfix", value: "bugfix"},
];

export const productAreas = [
    "Goal",
    "Project",
    "Deliverable / Milestone",
    "Task",
    "Team",
    "Calendar",
    "Notification",
    "File",
    "Comment",
    "Report",
    "None / Unknown",
];

export const emptyBrief = {
    requestType: "",
    featureName: "",
    priority: "medium",
    involvedAreas: "",
    requester: "",
    requestDate: new Date().toISOString().slice(0, 10),
    codexMode: "analysis",
    problem: "",
    targetUser: "",
    targetRole: "",
    businessImpact: "",
    existingProductRelation: "",
    userScenario: [""],
    allowedRoles: [{role: "", action: "", description: ""}],
    deniedRoles: [{role: "", limitation: "", description: ""}],
    productLocation: "",
    expectedOutcome: "",
    acceptanceCriteria: [""],
    connectedAreas: [],
    outOfScope: [""],
    openQuestions: [""],
    dependencies: "",
    technicalNotes: {
        backendReceiptPath: "",
        bcrPath: "",
        knownEndpointOrContract: "",
        extraNotes: "",
    },
};

export const meetingExample = {
    ...emptyBrief,
    requestType: "new-feature",
    featureName: "جلسات پروژه",
    priority: "high",
    involvedAreas: "Project, Team, Calendar, Notification, Task",
    requester: "تیم محصول زوفینو",
    codexMode: "analysis",
    problem: "جلسه‌های پروژه خارج از زوفینو برگزار می‌شوند و تصمیم‌ها، افراد حاضر و کارهای خروجی جلسه پراکنده یا گم می‌شوند.",
    targetUser: "مدیر پروژه، اعضای پروژه و ناظر پروژه",
    targetRole: "مدیر پروژه / عضو پروژه / ناظر",
    businessImpact: "تصمیم‌ها و کارهای خروجی جلسه در همان پروژه قابل پیگیری باشند و تیم تصویر دقیق‌تری از وضعیت پروژه داشته باشد.",
    existingProductRelation: "صفحه پروژه، تب‌های پروژه، تقویم تیم، اعلان‌ها و کارهای پروژه",
    userScenario: [
        "مدیر پروژه وارد صفحه پروژه می‌شود.",
        "تب جلسات را باز می‌کند.",
        "جلسه‌ای با عنوان، زمان، مکان یا لینک، دستور جلسه و اعضا می‌سازد.",
        "فقط اعضای همان پروژه برای انتخاب نمایش داده می‌شوند.",
        "جلسه در پروژه و تقویم تیم نمایش داده می‌شود.",
        "پس از جلسه، حضور افراد، تصمیم‌ها و کارهای خروجی ثبت می‌شوند.",
    ],
    allowedRoles: [
        {role: "مدیر پروژه", action: "ساخت، ویرایش، لغو جلسه و ثبت تصمیم‌ها", description: "دسترسی کامل به جلسه‌های همان پروژه"},
        {role: "عضو پروژه", action: "مشاهده جلسه‌های پروژه", description: "فقط جلسه‌های پروژه‌هایی که عضو آن است"},
        {role: "ناظر", action: "مشاهده", description: "بدون امکان ایجاد یا ویرایش"},
    ],
    deniedRoles: [
        {role: "عضو خارج از پروژه", limitation: "عدم مشاهده یا ویرایش جلسه", description: "جلسات به پروژه محدود می‌شوند"},
        {role: "ناظر", limitation: "عدم ایجاد یا ویرایش تصمیم و کار", description: "ناظر فقط خواننده است"},
    ],
    productLocation: "صفحه پروژه، تب جلسات، تقویم تیم",
    expectedOutcome: "جلسه، تصمیم‌ها و کارهای خروجی در پروژه قابل مشاهده و قابل پیگیری باشند.",
    acceptanceCriteria: [
        "مدیر پروژه جلسه ایجاد و ویرایش می‌کند.",
        "فقط اعضای پروژه در انتخاب اعضای جلسه دیده می‌شوند.",
        "جلسه در تب جلسات پروژه نمایش داده می‌شود.",
        "جلسه در تقویم تیم نمایش داده می‌شود.",
        "تصمیم‌ها و کارهای خروجی قابل ثبت هستند.",
        "اگر Backend Contract کافی نیست، BCR ساخته می‌شود.",
    ],
    connectedAreas: ["Project", "Task", "Team", "Calendar", "Notification"],
    outOfScope: [
        "ضبط صوت یا ویدئوی جلسه",
        "اتصال مستقیم به ویدئوکنفرانس",
        "صورت‌جلسه هوشمند با AI",
    ],
    openQuestions: [
        "آیا ویرایشگر پروژه هم اجازه ساخت جلسه دارد؟",
        "آیا فرد غیرعضو با دعوت خاص می‌تواند در جلسه شرکت کند؟",
        "آیا ساخت جلسه باید Notification ایجاد کند؟",
    ],
};

export function sanitizeBrief(value) {
    if (!value || typeof value !== "object") return emptyBrief;
    return {
        ...emptyBrief,
        ...value,
        userScenario: normalizeList(value.userScenario, emptyBrief.userScenario),
        allowedRoles: normalizeRoleList(value.allowedRoles, emptyBrief.allowedRoles, ["role", "action", "description"]),
        deniedRoles: normalizeRoleList(value.deniedRoles, emptyBrief.deniedRoles, ["role", "limitation", "description"]),
        acceptanceCriteria: normalizeList(value.acceptanceCriteria, emptyBrief.acceptanceCriteria),
        connectedAreas: Array.isArray(value.connectedAreas) ? value.connectedAreas : [],
        outOfScope: normalizeList(value.outOfScope, emptyBrief.outOfScope),
        openQuestions: normalizeList(value.openQuestions, emptyBrief.openQuestions),
        technicalNotes: {
            ...emptyBrief.technicalNotes,
            ...(value.technicalNotes || {}),
        },
    };
}

export function validateBrief(brief) {
    const errors = {};

    required(errors, "requestType", brief.requestType);
    required(errors, "featureName", brief.featureName);
    required(errors, "problem", brief.problem);
    required(errors, "targetUser", brief.targetUser);
    required(errors, "expectedOutcome", brief.expectedOutcome);

    if (!hasFilledItem(brief.userScenario)) errors.userScenario = "pbb-error-scenario";
    if (!hasFilledRole(brief.allowedRoles)) errors.allowedRoles = "pbb-error-access";
    if (!hasFilledItem(brief.acceptanceCriteria)) errors.acceptanceCriteria = "pbb-error-acceptance";

    return errors;
}

export function isBriefValid(brief) {
    return Object.keys(validateBrief(brief)).length === 0;
}

function required(errors, key, value) {
    if (!String(value || "").trim()) errors[key] = "pbb-error-required";
}

function hasFilledItem(items) {
    return Array.isArray(items) && items.some((item) => String(item || "").trim());
}

function hasFilledRole(items) {
    return Array.isArray(items) && items.some((item) => String(item?.role || item?.action || item?.description || item?.limitation || "").trim());
}

function normalizeList(value, fallback) {
    return Array.isArray(value) && value.length ? value.map((item) => String(item || "")) : fallback;
}

function normalizeRoleList(value, fallback, keys) {
    if (!Array.isArray(value) || !value.length) return fallback;
    return value.map((item) => keys.reduce((acc, key) => ({...acc, [key]: String(item?.[key] || "")}), {}));
}
